import React, { useState, createContext } from 'react';
import { initAuth } from './helpers/validation/tokenValidation';

export const AppContext = createContext()

export const AppProvider = React.memo(({ children }) => {
    const [language, setLanguage] = useState(process.env.REACT_APP_DEFAULT_LANG_LIST.split(',')[0]);
    const [fontSize, setFontSize] = useState(16);
    const [isAudiodescription, setIsAudiodescription] = useState(false);
    const [alert, setAlert] = useState({state: '', text: ''});
    const [isHighContrast, setIsHighContrast] = useState(2);

    const [isAuthorize, setIsAuthorize] = useState(() => {
        try{
            const authState = JSON.parse(localStorage.getItem("auth_state"));
            if(authState?.state)
                return authState;
            else
                throw new Error();
        }catch(e){
            localStorage.removeItem("auth_state");
            return initAuth;
        }
    });

    const [cookieConsent, setCookieConsent] = useState(() => {
        try{
            const savedCookieConsent = JSON.parse(localStorage.getItem("cookie_consent"));
            if(!savedCookieConsent?.isOpen && savedCookieConsent?.isSave && savedCookieConsent?.necessary)
                return savedCookieConsent;
            else
                throw new Error();
        }catch(e){
            localStorage.removeItem("cookie_consent");
            return {
                isOpen: true,
                isSave: false,
                necessary: true,
                analytics: false
            }
        }
    });

    return (
        <AppContext.Provider 
            value={{
                language,
                setLanguage,
                fontSize,
                setFontSize,
                isAudiodescription,
                setIsAudiodescription,
                alert,
                setAlert,
                isAuthorize,
                setIsAuthorize,
                isHighContrast, 
                setIsHighContrast,
                cookieConsent,
                setCookieConsent
            }}
        >
            {children}
        </AppContext.Provider>
    )
})